import { Outlet } from 'react-router-dom';
import Header from '@components/layout/Header';
import Sidebar from '@components/layout/Sidebar';
import Footer from '@components/layout/Footer';
import { useAuth } from '@hooks/useAuth';

const MainLayout = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="h-screen overflow-hidden bg-gradient-to-br from-primary-50 via-secondary-50 to-primary-100 flex">
      {isAuthenticated && <Sidebar />}
      
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        
        <main className="flex-1 overflow-y-auto overflow-x-hidden scroll-smooth min-w-0 bg-gradient-to-br from-primary-50 via-secondary-50 to-primary-100">
          <div className={isAuthenticated ? "p-3 sm:p-4 min-h-full min-w-0 max-w-full" : "min-h-full min-w-0 max-w-full"}>
            <Outlet />
          </div>
        </main>
        
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;